import axios from "axios";
import { APICall } from ".";


export const HIS_TOKEN_PARAM = "token";
export const HIS_NATIONAL_ID_PARAM = "natioanlID";

const ControllerName = "AuthHoloolHIS"

export const GenerateHisToken = ({ userId, nationalId }: { userId: string, nationalId: string }) => {
    return axios.post(`${window.Integration_URL}api/AuthIntegrationHIS/generate-random-token`, {
        userId,
        nationalId
    },
        {
            headers: {
                "X-Api-Key": window.TestHISKey,
            },
        })
};

export const ExchangeHisToken = (HISGeneratedToken: any) => {
    return APICall("POST", `${ControllerName}/exchange-token`, HISGeneratedToken)
};
